module.exports = __webpack_public_path__ + "static/media/Item 3.664b131c.jpg";